module.exports = __webpack_public_path__ + "media/images/kyoto_en01-c5b70b25e8ba90789ce027917f4074a3.jpg";